import { useState } from "react";
import { Box, Grid, Stack } from "@mui/material";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import ByzMuiSelect from "src/components/core-components/mui/ByzMuiSelect";
import ByzMuiTextField from "src/components/core-components/mui/inputs/ByzMuiTextField";
import { useTranslate } from "src/locales";
import { ByzMuiCheckBox } from "src/components/core-components/mui/ByzMuiCheckBox";
//IDOGAN;453142;03042025

const ComplicationTypePanel = () => {
  const { t } = useTranslate();

  const [selectedComplication, setSelectedComplication] = useState<any[]>([]);

const complicationOptions = [
  { value: "flebit", label: "Flebit" },
  { value: "infiltrasyon", label: "İnfiltrasyon" },
  { value: "enfeksiyon", label: "Giriş Yeri Enfeksiyonu" },
];

  const selectedLabel = selectedComplication[0]?.label;

  return (
    <Box
      sx={{
        padding: "20px",
        width: "100%",
      }}
    >
      <Grid container spacing={1}>
        {!selectedLabel ? (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <Grid
              md={6}
              xs={6}
              sx={{
                borderBottom: "1px solid #E0E0E0",
                height: "56px",
                alignItems: "center",
                display: "flex",
                backgroundColor: "#F4F7FE",
              }}
            >
              <ByzMuiTypography isTitle >
              {t("catheter-material-tracking.complication-type-title")}
              </ByzMuiTypography>
            </Grid>
            <Grid md={6} xs={6}>
              <ByzMuiSelect
                sx={{ width: "100%" }}
                options={complicationOptions}
                label="label"
                placeholder={t("select")}
                multiple={false}
                value={selectedComplication[0] || null}
                onChange={(event: any, newValue: any) =>
                  setSelectedComplication(newValue ? [newValue] : [])
                }
                renderInput={(params: any) => <ByzMuiTextField {...params} />}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid
            container
            alignItems="center"
            justifyContent="space-between"
            mb={1}
          >
            <Grid item xs={8} md={8}>
              <Box
                sx={{
                  backgroundColor: "#F4F7FE",
                  padding: "10px 20px",
                  borderRadius: "5px",
                }}
              >
                <ByzMuiTypography
                  isTitle
                  sx={{
                    marginLeft: "0px",
                    textAlign: "left",
                  }}
                >
                  {t("catheter-material-tracking.complication-type-title")} {selectedLabel} 
                </ByzMuiTypography>
              </Box>
            </Grid>
            <Grid md={4} xs={4}>
              <Stack direction="row" spacing={1}>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ByzMuiTypography marginLeft="0">{t("catheter-material-tracking.value")}</ByzMuiTypography>
                </Box>
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <ByzMuiTypography marginLeft="0">{t("catheter-material-tracking.selection")}</ByzMuiTypography>
                </Box>
              </Stack>
            </Grid>
          </Grid>
        )}
        {selectedLabel === "Flebit" && (
          <>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "48px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                  }}
                >
                  {t("catheter-material-tracking.no-symptom")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">0</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "80px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                 {t("catheter-material-tracking.symptom-0")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">1</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "80px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-1")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">2</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "96px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                {t("catheter-material-tracking.symptom-2")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">3</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "96px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-3")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">4</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </>
        )}
        {selectedLabel === "İnfiltrasyon" && (
          <>
            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "48px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                  }}
                >
                  {t("catheter-material-tracking.no-symptom")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">0</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "64px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-4")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">1</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "80px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-5")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">2</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "80px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-6")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">3</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>

            <Grid
              container
              alignItems="center"
              justifyContent="space-between"
              mb={1}
            >
              <Grid
                md={8}
                xs={8}
                sx={{
                  borderBottom: "1px solid #E0E0E0",
                  height: "112px",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <ByzMuiTypography
                  sx={{
                    marginLeft: "30px",
                    textAlign: "left",
                    whiteSpace: "pre-line",
                  }}
                >
                  {t("catheter-material-tracking.symptom-7")}
                </ByzMuiTypography>
              </Grid>
              <Grid md={4} xs={4}>
                <Stack direction="row" spacing={1}>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                      alignItems: "center", 
                      justifyContent: "center",
                    }}
                  >
                    <ByzMuiTypography marginLeft="0">4</ByzMuiTypography>
                  </Box>
                  <Box
                    sx={{
                      width: "100%",
                      height: "48px",
                      border: "1px solid #2196F3",
                      borderRadius: "7px",
                      display: "flex",
                      paddingLeft: "5px",
                    }}
                  >
                    <ByzMuiCheckBox />
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default ComplicationTypePanel;
